import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {UserService} from '../services/user.service';
import {catchError, map, tap} from 'rxjs/operators';
import {StateProviderService} from '../services/state-provider.service';
import {UserPermissionsService} from '../services/user-permissions.service';
import {ERRORS, PAGES_CONFIG} from '../constants/pages.constants';
import {HttpErrorResponse} from '@angular/common/http';
import {PitMsalService} from '../services/pit-msal.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    public router: Router,
    private userService: UserService,
    private pitMsalService: PitMsalService,
    private stateProviderService: StateProviderService,
    private userPermissionService: UserPermissionsService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.userService.isLoggedInProduceit()) {
      return true;
    }
    return this.userService.login().pipe(
      map((userGroupRoles: string[]) => {
        this.userService.setLoggedInProduceit(true);
        this.userPermissionService.setUserRoles(userGroupRoles);
        return true;
      }),
      tap(() => {
        this.userService.updateUserDetails();
      }),
      catchError(err => {
        if(err instanceof HttpErrorResponse) {
          // 500 status is not included into the condition because it may point to an isolated BE error
          if(err.status > 500 || err.status === 0) {
            this.stateProviderService.putParam('error', ERRORS.serviceUnavailable);
            this.stateProviderService.putParam('original', state);

            this.router.navigate([PAGES_CONFIG.ERROR]);
            return of(false);
          }
          // 400 status when user logins with invalid credentials/token/header
          if(err.status === 400) {
            this.userService.resetUser();
            this.pitMsalService.logout();
            return of(false);
          }
        }
        this.stateProviderService.putParam('user', this.userService.getCurrentUserName());
        this.router.navigate([PAGES_CONFIG.ERROR_AUTH]);
        return of(false);
      })
    );
  }
}
